import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { ArApOffsetsDto } from "../../../../dtos/documents/ArApOffsets/ArApOffsetsDto";
import { FormProvider, Resolver, useForm } from "react-hook-form";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { NFLookupDivision } from "../../../Shared/NewForms/NFLookupDivision";
// import { PostingOfGoodsModel } from "../../../../models/Documents/PostingOfGoodsModel";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFLookupVendorCustomer } from "../../../Shared/NewForms/NFLookupVendorCustomer";
import { ArapOffSetsModel } from "../../../../models/Documents/ArApOffSetsModel/ArApOffSetsModel";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import * as XLSX from "xlsx";
import { NFLookupCurrency } from "../../../Shared/NewForms/NFlookupCurrency";
import { NFLookupEmployee } from "../../../Shared/NewForms/NFLookupEmployee";
import { NFLookupDriver } from "../../../Shared/NewForms/NFLookupDriver";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import useRunError from "../../../Shared/useRunError";
import { useAppSelector } from "../../../../redux/hooks/hooks";
import { selectSubmitCounter } from "../../../../redux/slices/submitCounterSlice";
import ArApOffsetsDetailSkeleton from "./ArApOffsetsDetailSkeleton";
import { ArApOffsetsDetailFooter } from "./ArApOffsetsDetailFooter";
import { AppEntities } from "../../../../config/entities";
import { importFromExcel } from "../../../../helpers/SaveObjectToExcel";
import { saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
interface IProps {
  model: ArApOffsetsDto | null;
  modelUpdatedEvent: (newModel: ArApOffsetsDto) => void;
}

// const resolver: Resolver<OpenBalanceOfGoodsDto> = async (values) => {
//     return {
//         values: values.documentNumber ? values : {},
//         errors: !values.documentNumber
//             ? {
//                 documentNumber: {
//                     type: 'required',
//                     message: 'This is required.',
//                 },
//             }
//             : {},
//     };
// };

export const ArapOffsetsDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("ArAp Off Sets");

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<ArapOffSetsModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;

  useEffect(() => {
    console.log(model);
    // register("postingOfGoodGoods");
    if (model) {
      setValue("id", model.id);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("comment", model.comment);
      setValue("createdDate", model.createdDate);
      setValue("amountLocalAccountsPayable", model.amountLocalAccountsPayable);
      setValue("amountLocalReceivable", model.amountLocalReceivable);
      setValue("amountAccountsPayable", model.amountAccountsPayable);
      setValue("amountReceivable", model.amountReceivable);
      setValue("transaction", model.transaction);
      setValue("debtorId", model.debtorId);
      setValue("writeOff", model.writeOff);
      setValue("writeOffItem", model.writeOffItem);
      setValue("amount", model.amount);
      setValue("creditorId", model.creditorId);
      setValue("debtorVendorConsumerId", model.debtorVendorConsumerId);
      setValue("creditorVendorConsumerId", model.creditorVendorConsumerId);
      setValue("partnerReceivableId", model.partnerReceivableId);
      setValue("partnerAccountsPayableId", model.partnerAccountsPayableId);
      setValue("arApObjectReceivableId", model.arApObjectReceivableId);
      setValue("arApObjectAccountsPayableId", model.arApObjectAccountsPayableId);
      setValue("currencyReceivableId", model.currencyReceivableId);
      setValue("currencyAccountsPayableId", model.currencyAccountsPayableId);
      setValue("managerId", model.managerId);
      setValue("divisionId", model.divisionId);
      setValue("companyId", model.companyId);
      setValue("partnerId", model.partnerId);
      setValue("currencyId", model.currencyId);
    }
  }, [model]);

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: ArapOffSetsModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return (
      <>
        <ArApOffsetsDetailSkeleton />
      </>
    );
  }
  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };
  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.OpenBalanceOfGoods.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };
  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        {/* <NFTab title={"Products"} /> */}
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        />

        {/* <!-- Tabs --> */}

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <div className={"panel-body tabs-menu-body main-content-body-right"}>
            <Row>
              <Col sm={6}>
                <NFTextInput title={"Document #"} disabled fieldName={"documentNumber"} />
              </Col>
              <Col sm={6}>
                <NFDateInput title={"Document Date"} fieldName={"documentDate"} required={true} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFDateInput title={"Created Date"} fieldName={"createdDate"} required={true} />
              </Col>
              <Col sm={6}>
                <NFLookupDivision fieldName={"divisionId"} title={"Division"} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFLookupVendorCustomer fieldName={"creditorVendorConsumerId"} title={"Creditor Vendor Consumer"} />
              </Col>
              <Col sm={6}>
                <NFLookupVendorCustomer fieldName={"debtorVendorConsumerId"} title={"Debtor Vendor Consumer"} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFLookupCurrency title="CurrencyAccountsPayableId" fieldName="currencyAccountsPayableId" />
              </Col>
              <Col sm={6}>
                <NFLookupEmployee title="employee" fieldName="employeeId" />
              </Col>
              <Col sm={6}>
                <NFLookupCurrency title="CurrencyReceivableId" fieldName="currencyReceivableId" />
              </Col>
            </Row>
          </div>
        </NFTabContainer>

        {/* <NFTabContainer index={1} currentIndex={tabIndex}>

                    <div className={"panel-body tabs-menu-body main-content-body-right"}>
                        <NFormTable fieldArray={"ArApOffsets"}>
                            <NFLookupProduct fieldName={"productId"} title={"Product"} required={true} width={300} />
                            <NFIntInput fieldName={"quantity"} title={"Quantity"} width={100} />
                            <NFIntInput fieldName={"price"} title={"Price"} width={100} />
                            <NFIntInput fieldName={"amountLocalAccountsPa"} title={"Amount Local Accounts Payable"} width={100} />
                            <NFPlainText fieldName={"productVendorCode"} title={"Product Vendor Code"} width={150} />
                        </NFormTable>
                    </div>
                </NFTabContainer> */}

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <div className={"panel-body tabs-menu-body main-content-body-right"}>
            <Row>
              <Col sm={12}>
                <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
              </Col>
              <Col sm={6}>
                <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
              </Col>
            </Row>
          </div>
        </NFTabContainer>
      </div>
      <ArApOffsetsDetailFooter />
    </FormProvider>
  );
};
